export enum ErrorMessage {
  NO_OK_SUGGEST_RESPONSE = "Did not receive status code 200",
  EMPTY_SUGGESTIONS = "No suggestions to show",
  KEYWORDS_UNDEFINED = "Keywords are undefined!",
}

export enum TRACK_LABEL {
  SUGGEST_TIME = "wk.san_SuggestTime",
  SEARCH_Type = "wk.san_SearchType",
  FALLBACK = "wk.san_Fallback",
  COUNT_HITS = "wk.san_CountHits",
  SEARCH_TERM = "wk.san_SearchTerm",
  SEARCH_WORD_COUNT = "wk.san_SearchWordCount",
  EMPTY_STATE_TIME = "wk.san_EmptyStateTime",
  EMPTY_STATE_COUNT = "wk.san_EmptyStateCount",
  INITIAL_SEARCHBOX_TIME = "wk.san_InitialSearchBoxTime",
  SQUIRREL_SESSION_START = "san_SquirrelSessionStart",
  PAGELOAD_COMPLETE = "san_PageLoadComplete",
  SUGGEST_RENDER_TIME = "san_SuggestRenderTime",
  SUGGEST_POS = "wk.san_SuggestPos",
  TARGET_URL_FALLBACK = "san_TargetUrlResponseFallback",
}

export const FALLBACK_SEARCH_URL = (
  term: string,
  additionalLabels: object = { [TRACK_LABEL.TARGET_URL_FALLBACK]: "true" }
): string => {
  const trackingData = Object.assign(
    {
      "wk.san_SearchType": "search",
      "wk.san_ActiveSearch": "true",
      san_InitialSearch: "true",
      san_Interaction: "initial_search",
    },
    additionalLabels
  );

  const ref = `#t=${encodeURIComponent(JSON.stringify(trackingData))}`;
  const encodedTerm = encodeURIComponent(term);
  return `https:/*🤫*/
};

export enum STORAGE_ITEM {
  HISTORICAL_DATA = "squirrelHistoricalData",
}

export enum HISTORY_MODE {
  SELECT = "select",
  NORMAL = "normal",
}
